<mat-spinner
  [diameter]="diameter"
  data-e2e="loading-spinner-fragment"
></mat-spinner>
